<template>
  <div class="self-stretch flex flex-col justify-start items-stretch gap-6" data-testid="host-controls">
    <!-- Title + Invite others -->
    <div class="flex justify-between items-center gap-4">
      <div class="text-white text-2xl font-bold" data-testid="host-controls-title">
        {{ $te('participants_title') ? $t('participants_title') : 'Participants' }}
      </div>
      <button
        type="button"
        class="inline-flex items-center gap-2 text-primary text-sm font-medium hover:opacity-80 transition cursor-pointer shrink-0"
        @click="$emit('invite')"
        data-testid="host-controls-invite-button"
      >
        <lib-icon name="users/user-plus/outline" size="16" class="shrink-0" />
        <span>{{ $t('invite_others') }}</span>
      </button>
    </div>

    <!-- Audience participation (host / sponsor) -->
    <SwitchGroup as="div" class="flex justify-between items-start gap-4" v-if="canMute">
      <span class="flex flex-col">
        <SwitchLabel class="text-base font-medium text-white">
          {{ $t('audience_participation') }}
        </SwitchLabel>
        <SwitchDescription class="text-sm text-text-neutral-high mt-1">
          {{ $t('audience_participation_desc') }}
        </SwitchDescription>
      </span>

      <Switch
          :model-value="participation_enabled"
          @update:modelValue="onToggle"
          :disabled="!canMute"
          :class="[
            participation_enabled ? 'bg-primary' : 'bg-gray-700',
            'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-600 focus:ring-offset-2'
          ]"
          data-testid="host-controls-participation-switch"
      >
        <span
            aria-hidden="true"
            :class="[
              participation_enabled ? 'translate-x-5' : 'translate-x-0',
              'pointer-events-none inline-block size-5 transform rounded-full bg-white shadow transition duration-200 ease-in-out'
            ]"
        />
      </Switch>
    </SwitchGroup>

    <!-- Participation status (guests) -->
    <div v-else class="flex flex-col">
      <div>
        <span class="ui-indicator w-3 h-3 rounded-full inline-flex mr-[6px]" :class="[participation_enabled ? 'bg-primary' : 'bg-elements-red']"></span>
        <span class="text-text-neutral-extreme text-sm">{{ participation_enabled ? $t('participation_enabled') : $t('participation_disabled') }}</span>
      </div>
      <div class="text-text-neutral-medium text-xs mt-1 inline-flex">
        {{ participation_enabled ? $t('participation_enabled_msg_for_guests') : $t('participation_disabled_msg_for_guests') }}
      </div>
    </div>

    <!-- Participants -->
    <div class="flex flex-col gap-4">
      <div class="text-white text-base font-medium" data-testid="host-controls-count">
        {{ participants_number }}/{{ participants_limit }}
        {{ $t('participants') }}
      </div>
      <participants-list :participants="participants" />
    </div>
  </div>
</template>

<script>
import {
  Switch,
  SwitchGroup,
  SwitchLabel,
  SwitchDescription
} from '@headlessui/vue'
import LibIcon from "@/components/ui/LibIcon.vue";
import ParticipantsList from "@/components/session/ParticipantsList.vue";

export default {
  name: 'HostControls',

  components: {
    LibIcon,
    ParticipantsList,
    Switch,
    SwitchGroup,
    SwitchLabel,
    SwitchDescription
  },

  emits: ['commit', 'invite'],

  props: {
    participants_number: {
      type: Number,
      default: 0
    },
    participants_limit: {
      type: Number,
      required: true
    },
    userRole: {
      type: String,
      default: 'regular'
    },
    participation_enabled: {
      type: Boolean,
      default: false
    },
    participants: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    canMute() {
      return this.userRole === 'sponsor' || this.userRole === 'host'
    }
  },

  methods: {
    onToggle(val) {
      this.$emit('commit', val)
    }
  }
}
</script>
